module.exports = __webpack_public_path__ + "static/img/brand-third-2.d1571045.png";